function getDiff(obj1, obj2) {

    const diff = {};
    for (const key in obj1) {
        if (Object.prototype.hasOwnProperty.call(obj1, key)) {
            if (Array.isArray(obj1[key])) {
                if (isEqual(obj1[key], obj2[key])) {
                    continue;
                }
            } else if (obj1[key] === obj2[key]) {
                continue;
            }
            diff[key] = obj2[key];
        }
    }

    return diff;

}
function isEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) {
        return false;
    }
    for (let i = 0; i < arr2.length; i++) {
        if (!arr1.includes(arr2[i])) {
            return false;
        }
    }

    // return true if above checks are passed
    return true;
}

export { getDiff, isEqual };
